module.exports = __webpack_public_path__ + "img/0553ed0f-f09f-495a-b923-aac3f79ce004.008.570aec44.png";